import type { AboutSolutionCard } from '@/data/shared/aboutCopy';

import { trackEvent } from '@/utils/gtags';

const SECTION_ID = 'about_what_we_do';

/**
 * ### trackAboutSolutionSelection
 *
 * Records a click through from the About page to one of the two solution
 * pages. Reported as a content selection rather than a conversion: the lead
 * itself is reported by the inquiry form once it is submitted. Silently does
 * nothing when the analytics tag is absent, which is the case in development
 * and before consent.
 *
 * @param solutionId Which solution card was clicked
 */
export function trackAboutSolutionSelection(
  solutionId: AboutSolutionCard['id'],
) {
  trackEvent('select_content', {
    content_type: 'about_solution',
    item_id: solutionId,
    section_id: SECTION_ID,
  });
}
